import { COLORS } from './chartColors';
import { sortLabelsChronologically } from './helpers/dateHelpers';
import { parseDataKey } from './helpers/dataHelpers';

interface SelectedEntity {
  id: number;
  name: string;
}

interface ApplicationRecord {
  id: string;
  requisition_approved_to_hired_avg?: number;
}

interface ApplicationData {
  data: ApplicationRecord[] | { reportNotFound: boolean };
}

interface MonthlyAverages {
  [monthLabel: string]: number;
}

export const jobRequisitionApprovedToHiredTransformer = (
  data: Record<string, ApplicationData>,
  selectedEntities: SelectedEntity[]
) => {
  const monthlyAverages: MonthlyAverages = {};

  Object.entries(data).forEach(([key, value]) => {
    const { monthLabel, shouldInclude } = parseDataKey(key, selectedEntities);

    if (!shouldInclude) return;

    if (Array.isArray(value.data)) {
      const times: number[] = [];
      value.data.forEach((record: any) => {
        if (record.requisition_approved_to_hired_avg) {
          const value = parseFloat(record.requisition_approved_to_hired_avg as unknown as string);
          if (!isNaN(value)) {
            times.push(value);
          }
        }
      });
      if (times.length > 0) {
        const avg = times.reduce((sum, t) => sum + t, 0) / times.length;
        monthlyAverages[monthLabel] = parseFloat((avg / (24 * 60 * 60)).toFixed(1));
      }
    } else if (!value.data.reportNotFound) {
      return;
    }
  });

  const sortedLabels = sortLabelsChronologically(Object.keys(monthlyAverages));

  return {
    labels: sortedLabels,
    datasets: [
      {
        label: 'Average Days from Requisition Approved to Hired',
        data: sortedLabels.map((label) => monthlyAverages[label]),
        borderWidth: 1,
        backgroundColor: COLORS[0],
        fill: false
      }
    ]
  };
};
